<div
  class="rounded-xl border border-slate-200 bg-white p-2 sm:p-4 w-full h-full flex flex-col justify-between hover:shadow-md hover:border-slate-300 transition-all duration-150 cursor-pointer active:scale-[0.98] overflow-hidden"
  (click)="selectProducto()"
>
  <!-- Contenedor de Imagen Reparado -->
  @if (verImagen()) {
    <div
      class="-mx-2 -mt-2 sm:-mx-4 sm:-mt-4 mb-3 relative aspect-video overflow-hidden bg-slate-50 border-b border-slate-100"
    >
      @if (producto().url_imagen.length > 0) {
        <img
          loading="lazy"
          [ngSrc]="producto().url_imagen"
          fill
          [alt]="producto().codigo"
          (error)="onImageError()"
          (load)="onImageLoad()"
          class="object-cover transition-opacity duration-300"
          [class.opacity-0]="loading()"
          [class.opacity-100]="!loading()"
        />

        <!-- Skeleton con animación Shimmer -->
        @if (loading()) {
          <div
            class="absolute inset-0 bg-linear-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer flex flex-col justify-center items-center"
            role="status"
          >
            <i class="bi bi-image text-gray-300 text-3xl"></i>
          </div>
        }
      } @else {
        <!-- Fallback unificado -->
        <div class="w-full h-full bg-gray-50 flex flex-col items-center justify-center">
          <i class="bi bi-image-alt text-gray-300 text-4xl mb-1"></i>
          <span class="text-[10px] text-gray-400 font-bold uppercase tracking-tighter"
            >Sin imagen</span
          >
        </div>
      }
    </div>
  }

  <!-- Contenido de texto (Tu diseño original) -->
  <div class="flex flex-col gap-1">
      <span class="text-slate-500 text-xs sm:text-sm font-medium truncate">
      <i class="bi bi-upc-scan"></i> {{ producto().codigo }}
    </span>

    <div class="mb-1 sm:mb-2 select-none">
      <div class="text-sm sm:text-lg font-semibold text-slate-900 line-clamp-2 leading-tight">
        {{ producto().nombre }}
      </div>
      <div class="text-slate-500 text-xs sm:text-sm mt-0.5 sm:mt-1 flex items-center gap-1">
        <i class="bi bi-box"></i> {{ producto().stock_sucursal.stock }}
      </div>
    </div>
  </div>

  <!-- Sección de Precios (Tu diseño original) -->
  <div class="mt-2">
    @if (producto().descuento_campana_id && producto().precio_venta_final) {
      <div class="flex flex-col">
        <span class="text-slate-400 text-xs sm:text-sm line-through select-none leading-none">
          {{ producto().precio_venta_original | currency: 'PEN' : 'S/.' }}
        </span>
        <span class="text-accent-600 text-base sm:text-xl font-bold select-none">
          {{ producto().precio_venta_final | currency: 'PEN' : 'S/.' }}
        </span>
      </div>
    } @else {
      <span class="text-accent-600 text-base sm:text-xl font-bold select-none">
        {{ producto().precio_venta | currency: 'PEN' : 'S/.' }}
      </span>
    }
  </div>
</div>
